<template>
    <notifications
        :class="
            [
                'server-notifs',
                $i18n.locale === 'en' && 'lang-en',
            ].filter(Boolean)
        "
        :position="
            `bottom ${$i18n.locale === 'fa' ? 'right' : 'left'}`
        "
    />
</template>

<script>
export default {
    created() {
        this.notifs = serverNotifs;
    },
    mounted() {
        this.$nextTick(() => {
            for (const notif of this.notifs) {
                this.$notify({
                    duration: 6000,
                    ...notif,
                });
            }
        });
    },
};
</script>

<style lang="scss">
.server-notifs {
    direction: rtl;
    bottom: 40px !important;
    .notification-content {
        text-align: right;
    }
    &.lang-en {
        direction: ltr;

        .notification-content {
            text-align: left;
        }
    }
}
</style>
